import React, { createElement } from 'react';
import { formatImage } from '@ifeng/public_method';
import Style from './index.module.scss';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import { getThumbnailFromRecommend } from '@ifeng/lowcode_tool/src/method/common'
import Chip from 'Chip';

export interface NewsList_11_Props {
    // 通用样式
    style: object;
    // 数据源
    newsChip: TYPE_Chip;
    // 列设置
    colNum: number;
    colPadding: number;
    showColBorder: boolean;
    // 单条设置（padding， border）
    itemStyle: object;
    itemAlignCenter: boolean;
    itemHoverColor: string;
    // 缩略图设置
    showThumbnail: boolean;
    thumbnailWidth: number;
    thumbnailHeight: number;
    showThumbnailHoverScale: boolean;
    thumbnailStyle: object;
    // 标题设置
    titleStyle: object;
    // 描述设置
    showSummary: boolean;
    summaryStyle: object;
    moreText: string;
    moreStyle: object;
    // 时间设置
    showTime: boolean;
    timeStyle: object;
}

const NewsList_11: React.FC<NewsList_11_Props> = (props: NewsList_11_Props) => {
    const {
        style,
        newsChip,
        colNum = 1,
        colPadding,
        showColBorder,
        itemStyle,
        itemAlignCenter,
        itemHoverColor,
        showThumbnail,
        thumbnailWidth,
        thumbnailHeight,
        showThumbnailHoverScale,
        thumbnailStyle,
        titleStyle,
        showSummary,
        summaryStyle,
        moreText,
        moreStyle,
        showTime,
        timeStyle,
    } = props;

    const newsChipData = useChip(newsChip);
    const chipComponentData = formatChip(newsChip)

    return (
        <Chip {...chipComponentData}>
            <div className={Style.wrap} style={{ ...style }}>
                <div
                    className={Style.list}
                    style={{ marginLeft: -colPadding, marginRight: -colPadding }}
                >
                    {newsChipData.map((item, index) => {
                        const { title, url, summary, newsTime } = item;


                        return (
                            <div
                                className={`${Style.col} ${showColBorder ? Style.colBorder : ''}`}
                                style={{
                                    width: `${Math.floor((100 / colNum) * 100) / 100}%`,
                                    paddingLeft: colPadding,
                                    paddingRight: colPadding,
                                }}
                            >
                                {/* @ts-ignore */}
                                <div className={Style.itemHover} style={{ '--hover-color': itemHoverColor }}>
                                    <a href={url} target="_blank" className={`${Style.itemLink}`}>
                                        <div
                                            className={Style.item}
                                            style={{
                                                alignItems: itemAlignCenter ? 'center' : 'flex-start',
                                                ...itemStyle,
                                            }}
                                        >
                                            {showThumbnail ? (
                                                <div
                                                    className={`${Style.thumbnail} ${
                                                        showThumbnailHoverScale
                                                            ? Style.thumbnailHoverScale
                                                            : ''
                                                    }`}
                                                    style={{
                                                        width: thumbnailWidth,
                                                        height: thumbnailHeight,
                                                        ...thumbnailStyle
                                                    }}
                                                >
                                                    <img
                                                        src={formatImage(
                                                            getThumbnailFromRecommend(item),
                                                            thumbnailWidth,
                                                            thumbnailHeight,
                                                        )}
                                                        alt={title}
                                                    />
                                                </div>
                                            ) : null}
                                            <div className={Style.content}>
                                                <div className={Style.title} style={{ ...titleStyle }}>
                                                    <span className={Style.titleText}>{title}</span>
                                                </div>
                                                {showSummary ? (
                                                    <div
                                                        className={Style.summary}
                                                        style={{ ...summaryStyle }}
                                                    >
                                                        <span>{summary}</span>
                                                        {summary && moreText ? (
                                                            <span
                                                                className={Style.more}
                                                                style={{ ...moreStyle }}
                                                            >
                                                            {moreText}
                                                        </span>
                                                        ) : null}
                                                    </div>
                                                ) : null}
                                                {showTime ? (
                                                    <div
                                                        className={Style.time}
                                                        style={{ ...timeStyle }}
                                                    >
                                                        <span>{newsTime}</span>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <Mask visible={!newsChip.id} zIndex={3}>示例推荐位碎片—{newsChip.default.id}</Mask>
            </div>
        </Chip>
    );
};

export default NewsList_11;
